import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dismissAllTiles } from "@/services/review.service";
import { DismissAllTilesRequest } from "@/types/review.types";

export const useDismissAllTiles = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: DismissAllTilesRequest) => dismissAllTiles(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
  });
};
